import { createFileRoute } from "@tanstack/react-router";
import Utilaje from "@/pages/Utilaje";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/equipment/")({
  head: () => routeHead("/de/equipment/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Utilaje />
  );
}
